import { styled, Box } from "@mui/material";

const MessageUser = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.widgetStyles.userChatBubble.background,
  padding: "10px 13px",
  borderRadius: "5px 5px 0 5px",
  maxWidth: "70%",
  whiteSpace: "pre-line",
  wordBreak: "break-word",
  textAlign: "left",
  color: theme.palette.widgetStyles.userChatBubble.textColor,
  marginLeft: "auto",
  marginBottom: "3px",
  fontSize: "1.0625rem",
}));

export default MessageUser;
